



































































































































































































































































import { Campaign, CampaignCall, CampaignCallStatus, CampaignContact, CampaignTopStats } from '@/data/models/campaign.model';
import { Contatto } from '@/data/models/contatto.model';
import { Headquarter } from '@/data/models/headquarter.model';
import { Page } from '@/data/models/page.model';
import { Search, SortDirection } from '@/data/models/search.model';
import { User } from '@/data/models/user.model';
import { CallCenterService } from '@/data/services/callcenter.service';
import { CampaignService } from '@/data/services/campaign.service';
import { CrudService } from '@/data/services/crud.service';
import { OfferService } from '@/data/services/offer.service';
import { newDate } from '@/data/utils/helper';
import store, { State } from '@/store';
import { cloneDeep } from 'lodash';
import { Component, Inject, Vue } from 'vue-property-decorator';
import EditContatto from '../contatti/contatto/EditContatto.vue';
import CallCenterConfirm from './action/CallCenterConfirm.vue';
import CallCenterRecall from './action/CallCenterRecall.vue';
import CallCenterContatto from './CallCenterContatto.vue';
import CallCenterSidebar from './CallCenterSidebar.vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { AuthService } from '@/data/services/auth.service';

@Component({
	components: {
		CallCenterContatto,
		CallCenterSidebar,
		ValidationObserver,
		ValidationProvider
	}
})
export default class CallCenter extends Vue {

	@Inject('CallCenterService') callcenterService!: CallCenterService;
	@Inject('CampaignService') campaignService!: CampaignService;
	@Inject('OfferService') offerService!: OfferService;
	@Inject('CrudService') callsCrudService!: CrudService<CampaignCall>;
	@Inject('CrudService') contattoCrudService!: CrudService<Contatto>;
	@Inject('AuthService') authService!: AuthService;

	next: CampaignContact | null = null;
	user: User | null = null;

	campaignid: number | null = null;
	recalls: number = 0;
	
	showSidebar: boolean = false;
	campaigns: Campaign[] = [];
	calls: CampaignCall[] = [];
	stats: CampaignTopStats[] = [];
	isModalEmailOpen: boolean = false;
	mailTemplate!: {offerid: number; body: string};

	loading: boolean = false;
	error?: string | null = null;

	state!: State;

	constructor() {
		super();
		this.state = store;
	}

	created() {
		this.user = store.user!;
		if (store.user!.campaigns) {
			this.campaigns = store.user!.campaigns;
			if (this.campaigns.length === 1) {
				this.campaignid = this.campaigns[0].id;
				this.nextContact();
			}
		}
	}

	onCampaignChange() {
		this.nextContact();
	}

	nextContact() {

		this.loading = true;
		this.next = null;
		this.error = null;

		this.callcenterService.nextContact(this.campaignid as number).then(result => {

			this.next = result;
	
			const search = new Search('campaigncall');
			search.addSimpleFilter('contactid', result.contactid!);
			search.addSimpleFilter('operatorid', this.state.user!.id);
			search.addSimpleFilter('campaignid', this.campaignid as number);
			search.addSimpleFilter('status', CampaignCallStatus.RECALL);
		
			this.callsCrudService.countEntities(CampaignCall, 'campaigncall', search).then(counter => {
				this.recalls = counter.ct;
			}).catch(({ data }) => {
				this.error = data.msg || data.internal;
			}).finally(() => this.loading = false);
			
		}).catch(({ data }) => {
			this.error = data.msg || data.internal;
			this.loading = false;
		});

		this.loadCalls();
	}

	loadCalls() {
		const search = new Search('campaigncall');
		search.addSimpleFilter('operatorid', this.state.user!.id);
		search.addSimpleFilter('campaignid', this.campaignid as number);
		search.setSortField('calldate');
		search.setSortDirection(SortDirection.ASCENDING);
		this.callsCrudService.searchEntities(CampaignCall, 'campaigncall', search, new Page(100)).then(result => {
			this.calls = result;
		});
		this.campaignService.statsCalls(this.state!.user!.id, this.campaignid as number).then(result => this.stats = result);
	}

	sendEmail() {
		this.$buefy.dialog.confirm({
			message: this.$t('send-email-confirm') as string,
			type: 'is-info',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				const loading = this.$buefy.loading.open({});
				this.campaignService.sendMail(this.next!.id).then(() => {
					this.$buefy.notification.open({
						message: this.$t('send-mail-success').toString(),
						type: 'is-success',
					});
					this.callcenterService.sendAction('reject', this.next as CampaignContact).then(() => {
						this.nextContact();
					}).finally(() => {
						loading.close();
					});
				}).catch(({ data }) => {
					loading.close();
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				});
			}
		});
	}

	confirm() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: CallCenterConfirm,
			props: {
				model: this.next
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: CampaignContact) => {
					const loading = this.$buefy.loading.open({});
					this.callcenterService.sendAction('confirm', value).then(() => {
						modal.close();
						this.refreshDaily();
						this.nextContact();
					}).catch(({ data }) => {
						this.$buefy.notification.open({
							message: data.msg || data.internal,
							type: 'is-danger',
						});
					}).finally(() => {
						loading.close();
					});
				}
			}
		});
	}

	recall() {
		const d = newDate(true);
		d.setHours(d.getHours() + 1);
		const modMin = d.getMinutes() % 5;
		d.setMinutes(d.getMinutes() + (modMin ? 5 - modMin : 0));
		// default +1h
		this.next!.nextrecall = d;
		const modal = this.$buefy.modal.open({
			parent: this,
			component: CallCenterRecall,
			props: {
				model: this.next,
			},
			customClass: 'dialog',
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: CampaignContact) => {
					const loading = this.$buefy.loading.open({});
					this.callcenterService.sendAction('recall', value).then(() => {
						modal.close();
						this.nextContact();
					}).catch(({ data }) => {
						this.$buefy.notification.open({
							message: data.msg || data.internal,
							type: 'is-danger',
						});
					}).finally(() => {
						loading.close();
					});
				}
			}
		});
	}

	reject() {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-callcenter-reject') as string,
			type: 'is-warning',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				const loading = this.$buefy.loading.open({});
				this.callcenterService.sendAction('reject', this.next as CampaignContact).then(() => {
					this.nextContact();
				}).catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				}).finally(() => {
					loading.close();
				});
			},
		});
	}

	noAnswer() {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-callcenter-no-answer') as string,
			type: 'is-warning',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				const loading = this.$buefy.loading.open({});
				this.callcenterService.sendAction('noanswer', this.next as CampaignContact).then(() => {
					this.nextContact();
				}).catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				}).finally(() => {
					loading.close();
				});
			},
		});
	}

	remove() {
		this.$buefy.dialog.confirm({
			message: this.$t('warning-callcenter-remove') as string,
			type: 'is-danger',
			hasIcon: true,
			cancelText: this.$t('annulla') as string,
			onConfirm: () => {
				const loading = this.$buefy.loading.open({});
				this.callcenterService.sendAction('remove', this.next as CampaignContact).then(() => {
					this.nextContact();
				}).catch(({ data }) => {
					this.$buefy.notification.open({
						message: data.msg || data.internal,
						type: 'is-danger',
					});
				}).finally(() => {
					loading.close();
				});
			},
		});
	}

	anagrafica() {
		const modal = this.$buefy.modal.open({
			parent: this,
			component: EditContatto,
			props: {
				contatto: cloneDeep(this.next!.contact),
				editableAddress: false
			},
			hasModalCard: true,
			canCancel: false,
			events: {
				submit: (value: Contatto) => {
					this.contattoCrudService.saveEntity(Contatto, 'contact', value).then(result => {
						modal.close();
						this.next!.contact = result;
						this.$buefy.notification.open({
							message: this.$t('success-save') as string,
							type: 'is-success',
						});
					}).catch(({ data }) => {
						this.$buefy.notification.open({
							message: data.msg || data.internal,
							type: 'is-danger',
						});
					});
				}
			}
		});
	}

	private refreshDaily() {
		this.authService.getLoggedUser().then(result => this.user = result);
	}

	get campaign(): Campaign | undefined {
		if (!this.campaignid) return undefined;
		return this.campaigns.filter(c => c.id === this.campaignid)[0];
	}

	get headquarter(): Headquarter | undefined {
		return this.state.headquarter;
	}

	get showRecall(): boolean {
		if (!this.campaign) return false;
		return this.recalls < this.campaign.maxrecall;
	}
}
